import { useDeviceContext } from "@jidlomat/terminal-core/contexts/DeviceContext";
import { MealsListPage } from "../pages";
import { useTerminalFlow } from "./useTerminalFlow";

/**
 * Loads the flow of this fridge and mounts its two halves: the effects next to the page, so that they
 * keep running while a status screen covers it, and the page, which gets the flow or the news that it
 * could not be fetched. It lives under the device context because that is where it learns that the
 * boot query has settled.
 */
export const FlowHost = () => {
	const { appConnected, loading } = useDeviceContext();
	const { flow, failed } = useTerminalFlow(appConnected, !loading);

	return (
		<>
			{flow != null && <flow.Effects />}
			<MealsListPage flow={flow} flowFailed={failed} />
		</>
	);
};
